// Файл consent_panel_storage.js

/**
 * Модуль «consent panel storage» содержит логику, относящуюся к разделу «Consent Panel».
 * Он объединяет связанные обработчики, данные или элементы интерфейса и предоставляет их соседним модулям приложения.
 * Такое разделение упрощает сопровождение, тестирование и повторное использование этой части кода.
 */

import { apiService } from '../../services/api';
import { storage } from '../../utils/storage';



const COOKIE_NOTICE_STORAGE_KEY = 'cookie_consent_notice_v1';
const POLICY_VERSION = '1.0';
const REMINDER_DAYS = 30;


const read_consent = (storage_key) => {
    try {
        const raw = storage.get_item(storage_key);

        if (!raw) {
            return null;
        }

        return JSON.parse(raw);

    } catch {
        return null;
    }
};


const is_consent_still_valid = (storage_key) => {
    const data = read_consent(storage_key);

    if (!data || data.consent !== 'accepted') {
        return false;
    }

    if (data.version !== POLICY_VERSION) {
        return false;
    }

    const accepted_at = new Date(data.acceptedAt);

    if (Number.isNaN(accepted_at.getTime())) {
        return false;
    }

    const expires_at = new Date(accepted_at);
    expires_at.setDate(expires_at.getDate() + REMINDER_DAYS);

    return new Date() < expires_at;
};


const is_notice_still_recent = () => {
    try {
        const raw = storage.get_item(COOKIE_NOTICE_STORAGE_KEY);

        if (!raw) {
            return false;
        }

        const data = JSON.parse(raw);

        if (data.version !== POLICY_VERSION) {
            return false;
        }

        const shown_at = new Date(data.shownAt);

        if (Number.isNaN(shown_at.getTime())) {
            return false;
        }

        const expires_at = new Date(shown_at);
        expires_at.setDate(expires_at.getDate() + REMINDER_DAYS);

        return new Date() < expires_at;

    } catch {
        return false;
    }
};


const save_notice_shown = () => {
    try {
        storage.set_item(
            COOKIE_NOTICE_STORAGE_KEY,
            JSON.stringify({
                version: POLICY_VERSION,
                shownAt: new Date().toISOString(),
            }),
        );

    } catch {
        return;
    }
};


const save_consent = (preset, value) => {
    const payload = {
        consent: value,
        version: POLICY_VERSION,
        acceptedAt: new Date().toISOString(),
    };

    try {
        storage.set_item(
            preset.storage_key,
            JSON.stringify(payload),
        );

    } catch {
        return;
    }

    apiService.df({
        table_name: preset.log_table,
        params: payload,
    }).catch(() => {});
};


export {
    POLICY_VERSION,
    is_consent_still_valid,
    is_notice_still_recent,
    read_consent,
    save_consent,
    save_notice_shown,
};
